import { render } from "./AlumniInvolvementForm.vue?vue&type=template&id=5793eb44&scoped=true"
import script from "./AlumniInvolvementForm.vue?vue&type=script&lang=js"
export * from "./AlumniInvolvementForm.vue?vue&type=script&lang=js"

import "./AlumniInvolvementForm.vue?vue&type=style&index=0&id=5793eb44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5793eb44"]])

export default __exports__